import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import useLogin from '../../Autenticacion/Hooks/useLogin';
import { DetalleBitacoraHallazgoService } from '../Services/DetalleBitacoraHallazgoService';

const ModalDetalleHallazgoBitacora = ({ show, onHide, datosModal }) => {
	const { usuario } = useLogin();
	const [dataDetalleHallazgo, setDataDetalleHallazgo] = useState({});

	const obtenerValor = (...valores) => {
		return valores.find((valor) => valor !== undefined && valor !== null && valor !== '') || '';
	};

	const normalizarSigla = (valor) => String(valor || '').trim().toUpperCase();

	const obtenerCamposDetalle = (detalle) => {
		const indicador = normalizarSigla(detalle.indicadorSigla);
		const campos = [
			['ID', detalle.hallazgoId],
			['Origen', detalle.origen],
			['Codigo Sice', detalle.codigoSice],
			['Fecha Registro', detalle.fechaCreacion],
			['Fecha Limite Correccion', detalle.fechaLimiteCorreccion],
			['Indicador', [detalle.indicadorSigla, detalle.indicadorDescripcion].filter(Boolean).join(' - ')],
			['ID BIM', detalle.idBim],
			['Elemento', obtenerValor(detalle.elementoDescripcion, detalle.elementoSigla)],
			['Exigencia', obtenerValor(detalle.exigencia, detalle.exigenciaDescripcion)],
			['Problema', detalle.problemaDescripcion],
			['Observacion', detalle.observacion],
			['Severidad', detalle.severidad],
			['Fecha de Cierre', detalle.fechaCierre],
			['Macroubicacion', detalle.macroubicacion],
			['Ubicacion', detalle.ubicacion],
			['Calzada', detalle.calzada],
			['Km Inicio', detalle.kmInicio],
			['Km Fin', detalle.kmFinal],
		];

		if (['PAV', 'ILUE', 'CON', 'DEM', 'SOS'].includes(indicador)) {
			campos.push(['Hectometros', detalle.hectometro]);
		}

		if (indicador === 'VAR2') {
			campos.push(['Minutos', detalle.cantidadMinutos]);
		}

		return campos;
	};

	const obtenerDetalleHallazgo = async () => {
		if (!datosModal?.hallazgoId) {
			return;
		}

		const formEnvio = {
			datosBusqueda: {
				idHallazgo: datosModal.hallazgoId,
				idUsuario: usuario.id
			}
		};
		const resp = await DetalleBitacoraHallazgoService(formEnvio);
		if (resp && resp.status === 200 && resp.data) {
			setDataDetalleHallazgo(resp.data.detalleBitacoraHallazgo || {});
		}
	};

	useEffect(() => {
		if (show) {
			obtenerDetalleHallazgo();
		} else {
			setDataDetalleHallazgo({});
		}
	}, [show]);

	const detalle = dataDetalleHallazgo || {};
	const ubicacion = obtenerValor(detalle.ubicacion, detalle.macroubicacion);
	const camposDetalle = obtenerCamposDetalle(detalle);

	return (
		<Modal
			show={show}
			onHide={onHide}
			centered
			dialogClassName="bitacora-finding-modal"
			contentClassName="bitacora-finding-modal__content"
		>
			<div className="bitacora-finding-modal__shell">
				<div className="bitacora-finding-modal__header justify-content-end">
					<button type="button" className="bitacora-finding-modal__close" onClick={onHide} aria-label="Cerrar">
						<i className="ico-close"></i>
					</button>
				</div>

				<div className="bitacora-finding-modal__title">
					<strong>Hallazgo {detalle?.hallazgoId}</strong>
					<span>{ubicacion}</span>
				</div>

				<div className="bitacora-finding-modal__section">
					<h6>Detalle</h6>
					<ul>
						{camposDetalle.map(([label, value]) => (
							<li key={label}><strong>{label}:</strong> {obtenerValor(value)}</li>
						))}
					</ul>
				</div>
			</div>
		</Modal>
	);
};

export default ModalDetalleHallazgoBitacora;
